import { render, staticRenderFns } from "./HistoryFilterButtons.vue?vue&type=template&id=61f07bf5"
import script from "./HistoryFilterButtons.vue?vue&type=script&lang=ts"
export * from "./HistoryFilterButtons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports